

import React, { useRef } from 'react';
import { Menu } from 'primereact/menu';
import { Ripple } from 'primereact/ripple';
import { Badge } from 'primereact/badge';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../hooks/useAuthContext';

export const getAvatarMenuItems = ({ account, logout, navigate }) => [
  {
    label: "Mon profil utilisateur",
    icon: "pi pi-user",
    command: () => {
      navigate("/user/profile");
    },
  },
  {
    label: "Mes écoles",
    icon: "pi pi-home",
    command: () => {
      navigate("/user/schools");
    },
  },
  {
    label: "Super Admin",
    visible: account?.superadmin ? true : false,
    icon: "pi pi-cog",
    command: () => {
      navigate("/sys/schools");
    },
  },
  {
    separator: true,
  },
  {
    label: "Déconnexion",
    icon: "pi pi-sign-out",
    command: () => {
      logout();
    },
  },
];

const MeaAvatarDropdown = () => {

  const { account, logout } = useAuthContext();

  const navigate = useNavigate();
  const avatarMenu = useRef(null);

  const avatarMenuItems = getAvatarMenuItems({ account, logout, navigate });

  return (
    <ul
      className="list-none p-0 m-0 hidden lg:flex lg:align-items-center select-none lg:flex-row surface-section border-1 lg:border-none surface-border right-0 top-100 z-1 shadow-2 lg:shadow-none absolute lg:static"
    >
      <li className="border-top-1 surface-border lg:border-top-none">
        <Menu
          model={avatarMenuItems}
          popup
          ref={avatarMenu}
          id="popup_avatar_menu"
        />
        <a
          href="#"
          onClick={(event) => avatarMenu.current.toggle(event)}
          className="p-ripple flex p-2 lg:px-3 lg:py-2 align-items-center hover:surface-100 font-medium border-round cursor-pointer transition-duration-150 transition-colors w-full no-underline"
        >
          <div className="block text-right">
            <div className="text-900 font-medium">
              {account?.firstname} {account?.lastname}
            </div>
            <span className="text-600 font-medium text-sm">
              {account?.email}
            </span>
          </div>
          <img
            src={
              account?.avatar
                ?
                account?.avatar
                : "/images/user.png"
            }
            className="border-circle ml-2"
            style={{ width: "37px", height: "37px" }}
            alt="User"
          />

          <Ripple />
        </a>
      </li>
      <li>
        <a href="#"
          className="p-ripple lg:hidden flex p-2 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-duration-150 transition-colors w-full"
        >
          <i className="pi pi-user text-base lg:text-2xl mr-2 lg:mr-0 p-overlay-badge">
            <Badge severity="danger" />
          </i>
          <span className="block lg:hidden font-medium">
            Mon profil utilisateur
          </span>
          <Ripple />
        </a>
      </li>
      <li>
        <a
          className="p-ripple lg:hidden flex p-2 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-duration-150 transition-colors w-full"
        >
          <i className="pi pi-home text-base lg:text-2xl mr-2 lg:mr-0 p-overlay-badge">
            <Badge severity="danger" />
          </i>
          <span className="block lg:hidden font-medium">
            Mes écoles
          </span>
          <Ripple />
        </a>
      </li>
      <li>
        <a
          className="p-ripple lg:hidden flex p-2 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer
                          transition-duration-150 transition-colors w-full"
        >
          <i className="pi pi-user text-base lg:text-2xl mr-2 lg:mr-0 p-overlay-badge">
            <Badge severity="danger" />
          </i>
          <span className="block lg:hidden font-medium">
            Super Admin
          </span>
          <Ripple />
        </a>
      </li>
      <li>
        <a
          onClick={(e) => {
            e.preventDefault();
            logout();
          }}
          className="p-ripple lg:hidden flex p-2 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-duration-150 transition-colors w-full"
        >
          <i className="pi pi-sign-out text-base lg:text-2xl mr-2 lg:mr-0 p-overlay-badge">
            <Badge severity="danger" />
          </i>
          <span className="block lg:hidden font-medium">
            Déconnexion
          </span>
          <Ripple />
        </a>
      </li>
    </ul>
  )
}

export default MeaAvatarDropdown;